(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('VilleDetailController', VilleDetailController);

    VilleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ville', 'Etablissement'];

    function VilleDetailController($scope, $rootScope, $stateParams, previousState, entity, Ville, Etablissement) {
        var vm = this;

        vm.ville = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('josdaviApp:villeUpdate', function(event, result) {
            vm.ville = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
